
import { Action } from 'vuex-class';
import { Vue, Component, Watch } from "vue-property-decorator";
import TaLayoutHeader from "@/components/shared/layout/TaLayoutHeader.vue";
import LayoutLoading from "@/components/shared/layout/FblLayoutLoading.vue";
import PassCodeVerifyForm from '@/components/shared/form/PassCodeVerifyForm.vue';
import InfoModal from "@/plugins/notification/infoModal";
import { CheckOtpOutput } from "@fubonlife/tacallindiy-core-axios-sdk";
import LayoutFooter from '@/components/shared/layout/FblLayoutFooter.vue';


@Component({ components: { TaLayoutHeader, LayoutLoading, PassCodeVerifyForm, LayoutFooter } })
export default class OTPVerify extends Vue {

	@Action('setLoading') setLoading;

	userInfo: {
		custId?: string,
		mobile?: string
	} = {}

	created() {
		this.userInfo = {
			custId: this.$route.params.custId,
			mobile: this.$route.params.mobile
		}
	}

	// 遮蔽身分證
	get maskedCustId() {
		return this.userInfo.custId.replace(/(.{5}).*(.{3})/, '$1**$2');
	}

	// 遮蔽電話
	get maskedMobile() {
		return this.userInfo.mobile.replace(/(.{3}).*(.{2})/, '$1*****$2');
	}

	// 頁面橫幅
	imgRwd: string = "image_callin_desktop";
	screenWidth: number = 0;

	// 取得畫面寬度
	mounted() {
		this.screenWidth = document.body.clientWidth;

		window.onresize = () => {
			return (() => {
				this.screenWidth = document.body.clientWidth;
			})();
		};
	}
	// 載入橫幅 & 下拉式選單字體大小
	@Watch('screenWidth')
	widthChange() {
		if (this.screenWidth <= 500) {
			this.imgRwd = 'image_callin_mobile';
		} else if (500 < this.screenWidth && this.screenWidth <= 1024) {
			this.imgRwd = 'image_callin_tablet';
		} else {
			this.imgRwd = 'image_callin_desktop';
		}
	}

	// 重新寄送認證碼
	fetchResendPassCode() {
		this.setLoading(true)
		this.$CustomerControllerApi.chkIdAndMobleUsingPOST1(this.userInfo)
			.then(res => {
				if (res.status === 200) {
					InfoModal.alertModal({
						alertType: "success",
						title: "確認",
						content: "驗證碼已重新發送。",
						customContent: null,
					});
				} else {
					InfoModal.alertModal({
						alertType: "error",
						title: "錯誤",
						content: "驗證碼發送失敗，請重新嘗試。",
						customContent: null,
					});
				}
			})
			.finally(() => {
				this.setLoading(false)
			})
	}

	// 送出認證碼
	fetchSubmitPassCode(passCode: string) {
		this.setLoading(true);
		const otpCheck = { ...this.userInfo, otpNo: passCode }
		this.$CustomerControllerApi.chkOTPUsingPOST1(otpCheck)
			.then(res => {
				console.log(res)
				if (res.status === 200) {
					var result: CheckOtpOutput = JSON.parse(JSON.stringify(res.data));
					switch (result.returnCode) {
						case "01": // OTP驗證正確
							// sessionStorage.setItem('token', result.token);
							this.$router.replace({ name: "DispatchEmptyPage", query:{ token: result.token } });
							break;
						case "02": // OTP驗證正確，但超過5分鐘
							InfoModal.alertModal({
								alertType: "error",
								title: "錯誤",
								content: "認證碼已過期，請重新發送認證碼。",
								customContent: null,
							});
							break;
						case "03": // OTP驗證錯誤
							InfoModal.alertModal({
								alertType: "error",
								title: "錯誤",
								content: "認證碼錯誤，請重新輸入或重發認證碼。",
								customContent: null,
							});
							break;
						case "06": // OTP錯誤超過5次
							InfoModal.alertModal({
								alertType: "error",
								title: "錯誤",
								content: "錯誤超過5次，請重新發送認證碼。",
								customContent: null,
							});
							break;
					}
				} else {
					InfoModal.alertModal({
						alertType: "error",
						title: "錯誤",
						content: "認證碼驗證失敗，請重新嘗試。",
						customContent: null,
					});
				}
			})
			.finally(() => {
				this.setLoading(false);
			})
	}
}
